// removed by extract-text-webpack-plugin
module.exports = {"container":"LoadingSpinner-container","spinner":"LoadingSpinner-spinner","small":"LoadingSpinner-small"};


//////////////////
// WEBPACK FOOTER
// ./src/components/LoadingSpinner.scss
// module id = 747
// module chunks = 0